<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <GarageAccreditedForm v-if="garage" :garage="garage" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import GarageAccreditedForm from '@/components/settings/test-registers/garageAccredited/GarageAccreditedForm.vue'

  export default {
    name: 'GarageAccredited',
    components: {
      PageTitle,
      PageRowWrapper,
      GarageAccreditedForm
    },
    computed: {
      ...mapState({
        garage: state => state.garageaccredited.garageById
      })
    },
    methods: {
      ...mapActions('garageaccredited', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
